import React from 'react';

import { ColorChip } from './ColorChip';
import { OptionTypeBase } from './TagColorPicker.decl';

import { Select, ThemeProvider } from '@aircall/tractor-v2';
import { NEW_TAGS_COLORS } from '@constants/style.constants';
import { TagColorPickerInput } from '@pages/calls-tags/components/TagColorPicker/TagColorPickerInput';

import { TagColorPickerProps } from '.';

const OPTIONS = NEW_TAGS_COLORS.map((c) => ({ label: c, value: c }));

const renderOption = (option: OptionTypeBase, selectedValue: string | undefined) => (
  <ColorChip
    data-test={`color-chip-${option.value}`}
    color={option.value}
    outlined={selectedValue === option?.value}
  />
);

export function TagColorPicker(props: TagColorPickerProps) {
  const { onChange, value, dataTest = 'tag-color-picker' } = props;

  const handleChange = (newValues: string[]) => {
    onChange(newValues[0]);
  };

  return (
    <ThemeProvider>
      <Select
        options={OPTIONS}
        renderOption={(option) => renderOption(option, value as string)}
        trigger={<TagColorPickerInput value={value} dataTest={dataTest} />}
        selectedKeys={[value as string]}
        onSelectionChange={handleChange}
      />
    </ThemeProvider>
  );
}
